import type { HintTone } from './Hint';

const HINT_TONES = new Set<string>(['neutral', 'info', 'success', 'warning', 'danger'] satisfies HintTone[]);

/** Тон из конфигурации (`<hint tone>`): регистр и пробелы не важны, неизвестный — `info`. */
export const toHintTone = (tone?: string): HintTone => {
    const normalized = tone?.trim().toLowerCase();
    return normalized && HINT_TONES.has(normalized) ? (normalized as HintTone) : 'info';
};
